"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumButtonName = void 0;
/**
 * The unique analytics name of the button. This is used as part of the event name for button click events.
 * @export
 * @enum {string}
 */
exports.EnumButtonName = {
    Accept: 'Accept',
    AccessCodeSkip: 'AccessCodeSkip',
    AccessCodeSkipConfirm: 'AccessCodeSkipConfirm',
    AccessCodeSubmit: 'AccessCodeSubmit',
    AdditionalRecommendationsViewAll: 'AdditionalRecommendationsViewAll',
    AllClinicalProgramsCarouselBack: 'AllClinicalProgramsCarouselBack',
    AllClinicalProgramsCarouselForward: 'AllClinicalProgramsCarouselForward',
    AllLoginOptionsCta: 'AllLoginOptionsCTA',
    AlreadyHaveCalmAccount: 'AlreadyHaveCalmAccount',
    AnxietyHistoryInfo: 'AnxietyHistoryInfo',
    AudioPlayerDisableCc: 'AudioPlayerDisableCC',
    AudioPlayerEnableCc: 'AudioPlayerEnableCC',
    AudioPlayerPause: 'AudioPlayerPause',
    AudioPlayerPlay: 'AudioPlayerPlay',
    AudioPlayerStop: 'AudioPlayerStop',
    AudioPlayerBack15: 'AudioPlayerBack15',
    AudioPlayerForward15: 'AudioPlayerForward15',
    AudioPlayerNextTrack: 'AudioPlayerNextTrack',
    AudioPlayerPreviousTrack: 'AudioPlayerPreviousTrack',
    AppStoreDownload: 'AppStoreDownload',
    Back: 'Back',
    BackButton: 'BackButton',
    BackToScreening: 'BackToScreening',
    BrandLogo: 'BrandLogo',
    Call988: 'Call988',
    CallSamhsa: 'CallSAMHSA',
    CallSponsorSupport: 'CallSponsorSupport',
    CalmAppStoreDownload: 'CalmAppStoreDownload',
    CalmBusinessLearnMore: 'CalmBusinessLearnMore',
    CalmGooglePlayDownload: 'CalmGooglePlayDownload',
    CalmPromoCta: 'CalmPromoCta',
    CalmHealthPromoCta: 'CalmHealthPromoCta',
    Cancel: 'Cancel',
    Chat988: 'Chat988',
    CreateCalmAccount: 'CreateCalmAccount',
    ClinicalProgramsBack: 'ClinicalProgramsBack',
    ClinicalAuthorsCarouselBack: 'ClinicalAuthorsCarouselBack',
    ClinicalAuthorsCarouselForward: 'ClinicalAuthorsCarouselForward',
    CompletedSessionFavorite: 'CompletedSessionFavorite',
    CompletedSessionUnfavorite: 'CompletedSessionUnfavorite',
    Confirm: 'Confirm',
    ConfirmationOk: 'ConfirmationOk',
    Continue: 'Continue',
    ConvertAccount: 'ConvertAccount',
    ContinueGoogle: 'ContinueGoogle',
    ContinueApple: 'ContinueApple',
    ContinueFacebook: 'ContinueFacebook',
    ContinueEmail: 'ContinueEmail',
    CrisisCardLearnMore: 'CrisisCardLearnMore',
    CrisisDialogViewResults: 'CrisisDialogViewResults',
    CtaJoinProgram: 'CtaJoinProgram',
    CtaRestartProgram: 'CtaRestartProgram',
    DailyDetailTodaysDailyButton: 'DailyDetailTodaysDailyButton',
    DeleteAccount: 'DeleteAccount',
    DeleteAccountCancel: 'DeleteAccountCancel',
    DeleteAccountClose: 'DeleteAccountClose',
    DeleteAccountConfirm: 'DeleteAccountConfirm',
    DeleteAccountErrorConfirm: 'DeleteAccountErrorConfirm',
    DeleteAccountPrivacyPolicyLink: 'DeleteAccountPrivacyPolicyLink',
    DeleteCalmAccountInfoLink: 'DeleteCalmAccountInfoLink',
    DeleteAccountOk: 'DeleteAccountOk',
    DepressionHistoryInfo: 'DepressionHistoryInfo',
    DialogClose: 'DialogClose',
    DialogJoinProgram: 'DialogJoinProgram',
    DiscoverCalm: 'DiscoverCalm',
    DiscoverTab: 'DiscoverTab',
    DoNotAgree: 'DoNotAgree',
    DontHaveCalmAccount: 'DontHaveCalmAccount',
    EligibilityBack: 'EligibilityBack',
    EligibilityCancel: 'EligibilityCancel',
    EligibilityNotConfirmedClose: 'EligibilityNotConfirmedClose',
    EligibilityNotConfirmedOk: 'EligibilityNotConfirmedOk',
    EligibilitySkip: 'EligibilitySkip',
    EligibilitySubmit: 'EligibilitySubmit',
    EmailSupport: 'EmailSupport',
    EmailSponsorSupport: 'EmailSponsorSupport',
    EmailPreferencesLink: 'EmailPreferencesLink',
    ExploreCalm: 'ExploreCalm',
    Faqs: 'Faqs',
    FavoritesCarouselBack: 'FavoritesCarouselBack',
    FavoritesCarouselForward: 'FavoritesCarouselForward',
    ForYouCarouselBack: 'ForYouCarouselBack',
    ForYouCarouselForward: 'ForYouCarouselForward',
    FooterCalmBusinessLink: 'FooterCalmBusinessLink',
    FooterCalmHealthLink: 'FooterCalmHealthLink',
    FooterCalmLink: 'FooterCalmLink',
    FooterCareersLink: 'FooterCareersLink',
    FooterConsumerHealthDataPrivacyPolicyLink: 'FooterConsumerHealthDataPrivacyPolicyLink',
    FooterCookiesLink: 'FooterCookiesLink',
    FooterEmployersLink: 'FooterEmployersLink',
    FooterFaqLink: 'FooterFaqLink',
    FooterResourcesLink: 'FooterResourcesLink',
    FooterInquireLink: 'FooterInquireLink',
    FooterLinkedInLink: 'FooterLinkedInLink',
    FooterOptOutLink: 'FooterOptOutLink',
    FooterOverviewLink: 'FooterOverviewLink',
    FooterPressLink: 'FooterPressLink',
    FooterPrivacyLink: 'FooterPrivacyLink',
    FooterProvidersLink: 'FooterProvidersLink',
    FooterTermsLink: 'FooterTermsLink',
    FooterYoutubeLink: 'FooterYoutubeLink',
    GadScaleInfoClose: 'GadScaleInfoClose',
    GetStarted: 'GetStarted',
    GooglePlayDownload: 'GooglePlayDownload',
    GuideCardPlay: 'GuideCardPlay',
    GuideItemFavorite: 'GuideItemFavorite',
    GuideItemLocked: 'GuideItemLocked',
    GuideItemPlay: 'GuideItemPlay',
    GuideItemUnfavorite: 'GuideItemUnfavorite',
    GuidePlayerFavorite: 'GuidePlayerFavorite',
    GuidePlayerUnfavorite: 'GuidePlayerUnfavorite',
    HeaderTryCalm: 'HeaderTryCalm',
    HeaderTryCalmHealth: 'HeaderTryCalmHealth',
    HealthSummary: 'HealthSummary',
    HealthSummaryGenerate: 'HealthSummaryGenerate',
    HealthSummaryRetry: 'HealthSummaryRetry',
    HealthSummaryUpdate: 'HealthSummaryUpdate',
    HealthTab: 'HealthTab',
    HomeTab: 'HomeTab',
    HowToGetStartedNext: 'HowToGetStartedNext',
    InfoButton: 'InfoButton',
    LandingRegisterWeb: 'LandingRegisterWeb',
    LearnWhy: 'LearnWhy',
    LearnWhyClose: 'LearnWhyClose',
    LearnWhyViewProgram: 'LearnWhyViewProgram',
    LearnWhyViewDtc: 'LearnWhyViewDtc',
    LibraryViewAllCompletedPrograms: 'LibraryViewAllCompletedPrograms',
    LibraryViewAllFavorites: 'LibraryViewAllFavorites',
    LibraryViewAllRecentlyPlayed: 'LibraryViewAllRecentlyPlayed',
    LibraryFavoritesQuickNav: 'LibraryFavoritesQuickNav',
    LibraryRecentQuickNav: 'LibraryRecentQuickNav',
    LibraryCompletedQuickNav: 'LibraryCompletedQuickNav',
    Login: 'Login',
    LoginLandingBanner: 'LoginLandingBanner',
    LoginCalmAccount: 'LoginCalmAccount',
    Logout: 'Logout',
    LookingForCalmApp: 'LookingForCalmApp',
    ManageCalmAccount: 'ManageCalmAccount',
    MaximizePlayer: 'MaximizePlayer',
    MentalHealthByTheNumbers: 'MentalHealthByTheNumbers',
    MentalHealthCitation: 'MentalHealthCitation',
    MenuHowToGetStarted: 'MenuHowToGetStarted',
    MenuJoinProgram: 'MenuJoinProgram',
    MenuLeaveProgram: 'MenuLeaveProgram',
    MenuRestartProgram: 'MenuRestartProgram',
    MinimizePlayer: 'MinimizePlayer',
    MoreMenuOpen: 'MoreMenuOpen',
    MobileMenu: 'MobileMenu',
    MobileMenuClose: 'MobileMenuClose',
    NarratorsCarouselBack: 'NarratorsCarouselBack',
    NarratorsCarouselForward: 'NarratorsCarouselForward',
    NimhAnxiety: 'NIMHAnxiety',
    NimhDepression: 'NIMHDepression',
    NewSponsor: 'NewSponsor',
    NoAccessCode: 'NoAccessCode',
    NotMapped: 'NotMapped',
    NotYourEmployer: 'NotYourEmployer',
    NpsChoice: 'NpsChoice',
    OpenGuideTool: 'OpenGuideTool',
    PartnerLogo: 'PartnerLogo',
    PauseIntroVideo: 'PauseIntroVideo',
    PartnerAuthorizationAccept: 'PartnerAuthorizationAccept',
    PartnerAuthorizationBack: 'PartnerAuthorizationBack',
    PartnerAuthorizationCancel: 'PartnerAuthorizationCancel',
    PhqScaleInfoClose: 'PhqScaleInfoClose',
    PlanTab: 'PlanTab',
    PlayIntroVideo: 'PlayIntroVideo',
    PrivacyPolicy: 'PrivacyPolicy',
    ProfileEdit: 'ProfileEdit',
    LogoutCancel: 'LogoutCancel',
    LogoutConfirm: 'LogoutConfirm',
    ProfileSettings: 'ProfileSettings',
    ProfileScreeningHistory: 'ProfileScreeningHistory',
    ProfileScreeningMostRecent: 'ProfileScreeningMostRecent',
    ProfileTab: 'ProfileTab',
    ProfileUpdateScreening: 'ProfileUpdateScreening',
    ProgramHeaderNext: 'ProgramHeaderNext',
    ProgramInProgressConfirm: 'ProgramInProgressConfirm',
    ProgramMore: 'ProgramMore',
    ProgramOverviewNext: 'ProgramOverviewNext',
    ProgramOverviewTab: 'ProgramOverviewTab',
    ProgramPlay: 'ProgramPlay',
    ProgramPostSessionNext: 'ProgramPostSessionNext',
    ProgramScheduleNext: 'ProgramScheduleNext',
    ProgramScheduleTab: 'ProgramScheduleTab',
    ProgramViewDetails: 'ProgramViewDetails',
    RecentlyPlayedCarouselBack: 'RecentlyPlayedCarouselBack',
    RecentlyPlayedCarouselForward: 'RecentlyPlayedCarouselForward',
    RedirectRegistrationBeforeJoinProgram: 'RedirectRegistrationBeforeJoinProgram',
    RegisterConfirmed: 'RegisterConfirmed',
    RegisterNotConfirmed: 'RegisterNotConfirmed',
    ResendVerificationEmail: 'ResendVerificationEmail',
    ResumeIntroVideo: 'ResumeIntroVideo',
    RetakeMentalHealthSurveyFromCompleted: 'RetakeMentalHealthSurveyFromCompleted',
    RetakeMentalHealthSurveyFromResults: 'RetakeMentalHealthSurveyFromResults',
    ScreeningsBack: 'ScreeningsBack',
    ScreeningsForward: 'ScreeningsForward',
    SelectCondition: 'SelectCondition',
    SelectCountry: 'SelectCountry',
    SessionRatingNo: 'SessionRatingNo',
    SessionRatingYes: 'SessionRatingYes',
    SkipToMain: 'SkipToMain',
    SettingsCrisis: 'SettingsCrisis',
    SettingsEmail: 'SettingsEmail',
    SettingsFaq: 'SettingsFAQ',
    SettingsPhone: 'SettingsPhone',
    SettingsPrivacyPolicy: 'SettingsPrivacyPolicy',
    SettingsTerms: 'SettingsTerms',
    SettingsChdpp: 'SettingsChdpp',
    SetupConditions: 'SetupConditions',
    SetupGoals: 'SetupGoals',
    SetupTopics: 'SetupTopics',
    Signup: 'Signup',
    SignupLandingBanner: 'SignupLandingBanner',
    SignUpGoogle: 'SignUpGoogle',
    SignUpApple: 'SignUpApple',
    SignUpFacebook: 'SignUpFacebook',
    SignUpEmail: 'SignUpEmail',
    SponsorDetail: 'SponsorDetail',
    SponsorPhone: 'SponsorPhone',
    SponsorEmail: 'SponsorEmail',
    SponsorUpdate: 'SponsorUpdate',
    StandaloneScreeningStartCancel: 'StandaloneScreeningStartCancel',
    StandaloneScreeningStartContinue: 'StandaloneScreeningStartContinue',
    TermsOfService: 'TermsOfService',
    TosAccept: 'TosAccept',
    TryCalm: 'TryCalm',
    UpdateConditions: 'UpdateConditions',
    UpdateGoals: 'UpdateGoals',
    UpdateTopics: 'UpdateTopics',
    UpdatePlan: 'UpdatePlan',
    UpdatePlanScreening: 'UpdatePlanScreening',
    UpdatePlanTopics: 'UpdatePlanTopics',
    UpdatePlanConditions: 'UpdatePlanConditions',
    UpdatePlanGoals: 'UpdatePlanGoals',
    UseMobileApp: 'UseMobileApp',
    UseMobileAppBannerClose: 'UseMobileAppBannerClose',
    VideoPlayerBack15: 'VideoPlayerBack15',
    VideoPlayerDisableCc: 'VideoPlayerDisableCC',
    VideoPlayerEnableCc: 'VideoPlayerEnableCC',
    VideoPlayerForward15: 'VideoPlayerForward15',
    VideoPlayerMute: 'VideoPlayerMute',
    VideoPlayerPause: 'VideoPlayerPause',
    VideoPlayerPlay: 'VideoPlayerPlay',
    VideoPlayerToggleFullscreen: 'VideoPlayerToggleFullscreen',
    VideoPlayerUnmute: 'VideoPlayerUnmute',
    ViewAllRecommendations: 'ViewAllRecommendations',
    ViewAppStore: 'ViewAppStore',
    ViewCompletedProgram: 'ViewCompletedProgram',
    ViewDailyNarrator: 'ViewDailyNarrator',
    ViewLandingAuthor: 'ViewLandingAuthor',
    ViewLandingNarrator: 'ViewLandingNarrator',
    ViewGoal: 'ViewGoal',
    ViewPrivacyPolicy: 'ViewPrivacyPolicy',
    ViewProgramAuthor: 'ViewProgramAuthor',
    ViewProgramNarrator: 'ViewProgramNarrator',
    ViewTermsOfUse: 'ViewTermsOfUse',
    WatchLater: 'WatchLater',
    ContactSupport: 'ContactSupport',
    ErrorConfirm: 'ErrorConfirm',
    ToolButton: 'ToolButton',
    CloseSignIn: 'CloseSignIn',
    ContinueAsGuest: 'ContinueAsGuest',
    SignIn: 'SignIn',
    ChangeOfSponsorshipConfirmation: 'ChangeOfSponsorshipConfirmation',
    ChangeOfSponsorshipCancel: 'ChangeOfSponsorshipCancel',
    ChangeOfSponsorshipBack: 'ChangeOfSponsorshipBack',
    EnterAccessCodeCancel: 'EnterAccessCodeCancel',
    EnterAccessCodeContinue: 'EnterAccessCodeContinue',
    EnterAccessCodeDontHaveCode: 'EnterAccessCodeDontHaveCode',
    EnterAccessCodeLookingForCalmApp: 'EnterAccessCodeLookingForCalmApp',
    EnterAccessCodeSkip: 'EnterAccessCodeSkip',
    EligibilityCancel2: 'EligibilityCancel',
    EligibilityHaveDifferentAccessCode: 'EligibilityHaveDifferentAccessCode',
    EligibilityLookingForCalmApp: 'EligibilityLookingForCalmApp',
    SkipEligibility: 'SkipEligibility',
    SubmitEligibility: 'SubmitEligibility',
    SkipEligibilityCancel: 'SkipEligibilityCancel',
    SkipEligibilityClose: 'SkipEligibilityClose',
    SkipEligibilityConfirm: 'SkipEligibilityConfirm',
    SkipEligibilityLookingForCalmApp: 'SkipEligibilityLookingForCalmApp',
    SkipAccessCodeCancel: 'SkipAccessCodeCancel',
    SkipAccessCodeClose: 'SkipAccessCodeClose',
    SkipAccessCodeConfirm: 'SkipAccessCodeConfirm',
    SkipAccessCodeLookingForCalmApp: 'SkipAccessCodeLookingForCalmApp',
    SponsorUpdatedSuccessOk: 'SponsorUpdatedSuccessOk',
    RegistrationConfirmedGetStarted: 'RegistrationConfirmedGetStarted',
    RegistrationNotConfirmedGetStarted: 'RegistrationNotConfirmedGetStarted',
    CircleCreationContinue: 'CircleCreationContinue',
    CircleCreationPrivacyAndPolicy: 'CircleCreationPrivacyAndPolicy',
    CircleCreationTermsOfService: 'CircleCreationTermsOfService',
    Close: 'Close',
    ClosePlayer: 'ClosePlayer',
    Favorite: 'Favorite',
    ForwardFewSeconds: 'ForwardFewSeconds',
    Pause: 'Pause',
    Play: 'Play',
    RewindFewSeconds: 'RewindFewSeconds',
    Stop: 'Stop',
    Subtitles: 'Subtitles',
    GoalsFtueVideo: 'GoalsFtueVideo',
    ResetGoals: 'ResetGoals',
    SkipGoals: 'SkipGoals',
    SubmitGoals: 'SubmitGoals',
    ResetTopics: 'ResetTopics',
    SkipTopics: 'SkipTopics',
    SubmitTopics: 'SubmitTopics',
    TopicsBack: 'TopicsBack',
    TopicsFtueVideo: 'TopicsFtueVideo',
    DoneConditions: 'DoneConditions',
    AddCondition: 'AddCondition',
    AddConditions: 'AddConditions',
    ContinueConditions: 'ContinueConditions',
    SkipConditions: 'SkipConditions',
    ResetConditions: 'ResetConditions',
    ConditionsFtueVideo: 'ConditionsFtueVideo',
    ConditionMoreActions: 'ConditionMoreActions',
    ConditionDelete: 'ConditionDelete',
    ConditionDeleteConfirm: 'ConditionDeleteConfirm',
    ConditionDeleteCancel: 'ConditionDeleteCancel',
    CancelConditionSearch: 'CancelConditionSearch',
    ConditionsBack: 'ConditionsBack',
    SaveCondition: 'SaveCondition',
    ScreeningQuestionBack: 'ScreeningQuestionBack',
    QuitScreening: 'QuitScreening',
    QuitScreeningConfirm: 'QuitScreeningConfirm',
    ContinueScreening: 'ContinueScreening',
    StartMentalHealthSurvey: 'StartMentalHealthSurvey',
    SkipMentalHealthSurveyConfirm: 'SkipMentalHealthSurveyConfirm',
    SkipMentalHealthSurvey: 'SkipMentalHealthSurvey',
    MentalHealthSurveyFtueVideo: 'MentalHealthSurveyFtueVideo',
    MentalHealthSurveyBack: 'MentalHealthSurveyBack',
    MentalHealthSurveyGetStarted: 'MentalHealthSurveyGetStarted',
    SkipMentalHealthSurveyDialogClose: 'SkipMentalHealthSurveyDialogClose',
    QuitMentalHealthSurveyDialogClose: 'QuitMentalHealthSurveyDialogClose',
    ProceedToCarePlan: 'ProceedToCarePlan',
    MentalHealthSurveyRetriggerCard: 'MentalHealthSurveyRetriggerCard',
    MhsRetriggerGetStarted: 'MHSRetriggerGetStarted',
    MhsRetriggerLearnMore: 'MHSRetriggerLearnMore',
    MhsRetriggerSkipThisMonth: 'MHSRetriggerSkipThisMonth',
    AdditionalRecommendationsInfo: 'AdditionalRecommendationsInfo',
    BrowseByGoalBack: 'BrowseByGoalBack',
    BrowseByGoalForward: 'BrowseByGoalForward',
    ClinicalProgramCarouselBack: 'ClinicalProgramCarouselBack',
    ClinicalProgramCarouselForward: 'ClinicalProgramCarouselForward',
    DiscoverCarouselBack: 'DiscoverCarouselBack',
    DiscoverCarouselForward: 'DiscoverCarouselForward',
    DailiesCarouselBack: 'DailiesCarouselBack',
    DailiesCarouselForward: 'DailiesCarouselForward',
    TabCarePlanOverview: 'TabCarePlanOverview',
    TabCarePlanAllRecommendations: 'TabCarePlanAllRecommendations',
    TopRecommendationInfo: 'TopRecommendationInfo',
    ViewAllCategory: 'ViewAllCategory',
    ViewAllCondition: 'ViewAllCondition',
    ViewAllClinicalPrograms: 'ViewAllClinicalPrograms',
    ViewAllGoal: 'ViewAllGoal',
    ViewAllTopic: 'ViewAllTopic',
    Profile: 'Profile',
    UnsponsoredBanner: 'UnsponsoredBanner',
    TabToday: 'TabToday',
    TabLibrary: 'TabLibrary',
    CrisisReferralDialogOpen: 'CrisisReferralDialogOpen',
    ReferralDialogOpen: 'ReferralDialogOpen',
    ReferralDismiss: 'ReferralDismiss',
    ProgramCardViewProgram: 'ProgramCardViewProgram',
    ProgramCardJoinProgram: 'ProgramCardJoinProgram',
    ProgramCardDismissProgram: 'ProgramCardDismissProgram',
    DismissProgramSheetSnooze: 'DismissProgramSheetSnooze',
    DismissProgramSheetPermanent: 'DismissProgramSheetPermanent',
    DismissProgramSheetViewAll: 'DismissProgramSheetViewAll',
    DismissProgramSheetClose: 'DismissProgramSheetClose',
    DismissProgramSnoozeDialogSnooze: 'DismissProgramSnoozeDialogSnooze',
    DismissProgramSnoozeDialogKeep: 'DismissProgramSnoozeDialogKeep',
    DismissProgramSnoozeDialogClose: 'DismissProgramSnoozeDialogClose',
    DismissProgramPermanentDialogDismiss: 'DismissProgramPermanentDialogDismiss',
    DismissProgramPermanentDialogKeep: 'DismissProgramPermanentDialogKeep',
    DismissProgramPermanentDialogClose: 'DismissProgramPermanentDialogClose',
    GoToAccessCode: 'GoToAccessCode',
    NpsRateButton: 'NpsRateButton',
    NpsSkipButton: 'NpsSkipButton',
    QuickNav: 'QuickNav',
    StandaloneSurveyResourceSamhsa: 'StandaloneSurveyResourceSamhsa',
    StandaloneSurveyResourceAdaa: 'StandaloneSurveyResourceAdaa',
    StandaloneSurveyResourceNami: 'StandaloneSurveyResourceNami',
    ManageFriendsAndFamily: 'ManageFriendsAndFamily',
    InviteAddUpdate: 'InviteAddUpdate',
    CopyLink: 'CopyLink',
    EmailLink: 'EmailLink',
    ShareInvite: 'ShareInvite',
    ResendInvite: 'ResendInvite',
    WithdrawInvite: 'WithdrawInvite',
    WithdrawInviteConfirm: 'WithdrawInviteConfirm',
    WithdrawInviteCancel: 'WithdrawInviteCancel',
    FriendsUpdateToolTip: 'FriendsUpdateToolTip',
    ClearFromList: 'ClearFromList',
    RevokeAccess: 'RevokeAccess',
    RevokeAccessConfirm: 'RevokeAccessConfirm',
    RevokeAccessCancel: 'RevokeAccessCancel',
    ChangeOfSponsorshipFnfConfirmation: 'ChangeOfSponsorshipFnfConfirmation',
    EmailConfirmation: 'EmailConfirmation',
    Skip: 'Skip',
    PersonalizedRecommendations: 'PersonalizedRecommendations',
    TipsSuggestions: 'TipsSuggestions',
    Updates: 'Updates',
    SubmitNotificationTos: 'SubmitNotificationTos',
    TurnOffNotifications: 'TurnOffNotifications',
};
//# sourceMappingURL=enum-button-name.js.map